export const fontSize = {
  caption1: 12,
  caption2: 14,
  body: 16,
  title: 20,
};
